import { fetchApplicationSettingsAsync } from '../services/configuration/config';

export const getIsOnPrem = async (): Promise<boolean> => {
  const settings = await fetchApplicationSettingsAsync();
  return settings?.values?.ApplicationDeploymentMode?.toLowerCase() === 'onprem';
};

export const buildApiHeaders = async (baseHeaders: Record<string, string> = {}): Promise<Record<string, string>> => {
  const isOnPrem = await getIsOnPrem();

  const headers: Record<string, string> = {
    'content-type': 'application/json',
    ...baseHeaders,
  };

  if (isOnPrem) {
    headers['x-api-version'] = '2.0';
  }

  return headers;
};
